<template>
  <div>
    <Row class="text-center p-t-10">
      <RadioGroup v-model="pageType" size="small" @on-change="handleChangeType">
        <Radio label="1" border>站点静态指数研究</Radio>
        <Radio label="2" border>线路开通历程图</Radio>
        <Radio label="3" border>地图变灰DEMO</Radio>
      </RadioGroup>
    </Row>

    <component :is="currentComponent"></component>
  </div>
</template>

<script>
export default {
  components: {
    stationLevelComponent: () => import('./components/StationLevel'),
    lineHistoryComponent: () => import('./components/LineHistory'),
    demoComponent: () => import('./components/Demo')
  },
  data () {
    return ({
      pageType: '1',
      currentComponent: 'stationLevelComponent'
    })
  },
  methods: {
    handleChangeType (type) {
      switch (type) {
        case '1':
          this.currentComponent = 'stationLevelComponent'
          break
        case '2':
          this.currentComponent = 'lineHistoryComponent'
          break
        case '3':
          this.currentComponent = 'demoComponent'
          break
        default:
          this.currentComponent = 'lineHistoryComponent'
          break
      }
    }
  }
}
</script>
